import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./icon-card.module.css";
import { Search } from "../assets/search";
import { Phone } from "../assets/phone";
import { Store } from "../assets/store";
import { HomeDelivery } from "../assets/home-delivery";
export const IconCard = ({ icon ="search" , title , body  })=>{
    const validIcons = [
        "search",
        "phone",
        "store",
        "home-delivery"
    ];
    const isFallbackIcon = !validIcons.includes(icon);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.iconCardWrapper,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.iconCard,
                children: [
                    icon === "search" && /*#__PURE__*/ _jsx(Search, {}),
                    icon === "phone" && /*#__PURE__*/ _jsx(Phone, {}),
                    icon === "store" && /*#__PURE__*/ _jsx(Store, {}),
                    icon === "home-delivery" && /*#__PURE__*/ _jsx(HomeDelivery, {}),
                    isFallbackIcon && /*#__PURE__*/ _jsx(Search, {})
                ]
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: styles.iconCardHeading,
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.iconCardBody,
                children: body
            })
        ]
    });
};
